import { requestJson } from "./instateamAdminApi";

export function getAdminAttendanceOverview(token, params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value) !== "") {
      searchParams.set(key, value);
    }
  });

  return requestJson(`/instateam/attendance/admin/overview?${searchParams.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function reviewAdminAttendanceRegularization(token, attendanceId, payload) {
  return requestJson(`/instateam/attendance/admin/regularizations/${attendanceId}`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function reviewAdminCompOffRequest(token, attendanceId, payload) {
  return requestJson(`/instateam/attendance/admin/comp-offs/${attendanceId}`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateAdminAttendanceRecord(token, employeeId, payload) {
  return requestJson(`/instateam/attendance/admin/employee/${employeeId}`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function importAdminAttendanceRecords(token, rows) {
  return requestJson("/instateam/attendance/admin/import", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rows }),
  });
}
